<template lang="pug">

div
  h2(:class="headingVisible") E-mail style
  BriqColorInput(
    label="Header color" 
    name="PrimaryColor"
    v-model="emailSettings.PrimaryColor"
    :placeholder="placeholders.PrimaryColor"
    :disabled="isSaving" 
    help="Will be used for background-color topbar"
    )
  BriqColorInput(
    label="Button color" 
    name="SecondaryColor"
    v-model="emailSettings.SecondaryColor"
    :placeholder="placeholders.SecondaryColor"
    :disabled="isSaving"
    help="Will be used for background-color buttons" 
    )
  ImagePicker(
    label="Email Logo" 
    name="EmailLogo" 
    help="Only jpg/png allowed."
    v-model="emailSettings.EmailLogo" 
    :disabled="isSaving"
    )
  BriqRichEditorTextarea(
    label="Custom text confirmation e-mail" 
    name="CustomMailText"
    v-model="emailSettings.CustomMailText" 
    :placeholder="placeholders.CustomMailText"
    :disabled="isSaving"
    :allowHTMLEditor="true"
    :allowTemplateSyntax="true"
    @hasHTMLError="hasHTMLError"
    )
  BriqRichEditorTextarea(
    label="Custom text reminder e-mail" 
    name="CustomReminderMailText"
    v-model="emailSettings.CustomReminderMailText" 
    :placeholder="placeholders.CustomReminderMailText"
    :disabled="isSaving" 
    :allowHTMLEditor="true"
    :allowTemplateSyntax="true"
    @hasHTMLError="hasHTMLError"
    )
  .separator
  h2(:class="headingVisible") URLs
  BriqInput(
    label="Purchase site URL" 
    name="PurchaseSiteBaseUrl"
    v-model="emailSettings.PurchaseSiteBaseUrl" 
    :placeholder="placeholders.PurchaseSiteBaseUrl"
    :disabled="true" 
    )
  BriqInput(
    label="Company site URL" 
    name="EmailCompanyUrl"
    v-model="emailSettings.EmailCompanyUrl" 
    :placeholder="placeholders.EmailCompanyUrl"
    :disabled="isSaving" 
    )
  div.separator
  h2(:class="headingVisible") Templates E-mails
  BriqInput(
    label="E-mail reset password customer template slug"
    name="EmailPasswordResetTemplateName"
    v-model="emailSettings.EmailPasswordResetTemplateName" 
    :placeholder="placeholders.EmailPasswordResetTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail reset password user template slug"
    name="EmailPasswordResetUsersTemplateName"
    v-model="emailSettings.EmailPasswordResetUsersTemplateName" 
    :placeholder="placeholders.EmailPasswordResetUsersTemplateName"
    :disabled="isSaving" 
  )
  BriqInput(
    label="E-mail reset password user created template slug"
    name="EmailPasswordCreateUsersTemplateName"
    v-model="emailSettings.EmailPasswordCreateUsersTemplateName" 
    :placeholder="placeholders.EmailPasswordCreateUsersTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail booking completed template slug"
    name="BookingCompletedMailTemplateName"
    v-model="emailSettings.BookingCompletedMailTemplateName" 
    :placeholder="placeholders.BookingCompletedMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail booking completed offline template slug"
    name="BookingCompletedOfflineMailTemplateName"
    v-model="emailSettings.BookingCompletedOfflineMailTemplateName" 
    :placeholder="placeholders.BookingCompletedOfflineMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail booking cancelled template slug"
    name="BookingCancelledMailTemplateName"
    v-model="emailSettings.BookingCancelledMailTemplateName" 
    :placeholder="placeholders.BookingCancelledMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail booking paid template slug"
    name="BookingPaidMailTemplateName"
    v-model="emailSettings.BookingPaidMailTemplateName" 
    :placeholder="placeholders.BookingPaidMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail concept mail template slug"
    name="BookingConceptMailTemplateName"
    v-model="emailSettings.BookingConceptMailTemplateName" 
    :placeholder="placeholders.BookingConceptMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail evaluation mail template slug"
    name="EvaluationMailTemplateName"
    v-model="emailSettings.EvaluationMailTemplateName" 
    :placeholder="placeholders.EvaluationMailTemplateName"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail from address"
    name="EmailFromAddress"
    v-model="emailSettings.EmailFromAddress" 
    :placeholder="placeholders.EmailFromAddress"
    :error="emailFromAddressError"
    @blur="$v.emailSettings.EmailFromAddress.$touch()"
    :disabled="isSaving" 
    )
  BriqInput(
    label="E-mail reply to address"
    name="EmailReplyToEmailaddress"
    v-model="emailSettings.EmailReplyToEmailaddress" 
    :placeholder="placeholders.EmailReplyToEmailaddress"
    :error="emailReplyToEmailaddressError"
    @blur="$v.emailSettings.EmailReplyToEmailaddress.$touch()"
    :disabled="isSaving" 
    )
</template>

<script>
import BriqColorInput from '@v/components/BriqColorInput.vue'
import BriqRichEditorTextarea from '@v/components/BriqRichEditorTextarea.vue'
import ImagePicker from '@v/components/ImagePicker.vue'
import { email } from 'vuelidate/lib/validators'

export default {
  name: 'EmailSettingsPage',
  components: {
    BriqColorInput,
    BriqRichEditorTextarea,
    ImagePicker,
  },
  props: {
    emailSettings: Object,
    placeholders: Object,
    isSaving: Boolean,
    showSecondColumn: Boolean,
  },
  methods: {
    hasHTMLError(val) {
      this.$emit('hasHTMLError', val)
    }
  },
  computed: {
    emailFromAddressError() {
      return this.$v.emailSettings.EmailFromAddress.$invalid
        ? 'When provided, the E-mail from address should contain a valid e-mail address.'
        : null
    },
    emailReplyToEmailaddressError() {
      return this.$v.emailSettings.EmailReplyToEmailaddress.$invalid
        ? 'When provided, the E-mail reply to address should contain a valid e-mail address.'
        : null
    },
    headingVisible() {
      return this.showSecondColumn ? 'hidden' : ''
    },
  },
  watch: {
    emailSettings: {
      handler: function(val) {
        const canSave =
          !this.$v.emailSettings.EmailFromAddress.$invalid &&
          !this.$v.emailSettings.EmailReplyToEmailaddress.$invalid
        this.$emit('canSave', canSave)
      },
      immediate: true,
      deep: true,
    },
  },
  validations() {
    return {
      emailSettings: {
        EmailFromAddress: { email },
        EmailReplyToEmailaddress: { email },
      },
    }
  },
}
</script>
